module.exports = __webpack_public_path__ + "static/hermit-head-02-c9241e266ba7b0173eecf62c3c29fdb0.jpg";